export const getHostFromEmail = (email: string): string | undefined => {
	const [, host] = email.split('@');

	return host;
};

export const getEmailDomainNormalized = (email?: string): string => {
	return getHostFromEmail(email ?? '')?.toLowerCase() ?? '';
};

export const DOMAIN_REGEX = /^[a-z0-9]+([-.][a-z0-9]+)*\.[a-z]{2,}$/i;

export const isEmailDomainMatching = (emailDomain: string, allowedDomain: string): boolean => {
	return emailDomain === allowedDomain || emailDomain.endsWith(`.${allowedDomain}`);
};

export const BRINGG_INTERNAL_DOMAIN = 'bringg.com';

export const isEmailDomainAllowed = (email: string, allowedDomains: string[]): boolean => {
	if (!allowedDomains.length) {
		return true;
	}

	const domain = getEmailDomainNormalized(email);

	if (!domain) {
		return false;
	}

	if (domain === BRINGG_INTERNAL_DOMAIN) {
		return true;
	}

	return allowedDomains.some(allowed => isEmailDomainMatching(domain, allowed.toLowerCase()));
};
